"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_aim_1 = require("react-aim");
var UserMenuList_1 = __importDefault(require("./UserMenuList"));
var Counter_1 = __importDefault(require("../common/Counter"));
var LoginLink_1 = __importDefault(require("./LoginLink"));
var TdWebService_1 = __importDefault(require("../../service/TdWebService"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query UserMenuQuery {\n    viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  }\n"], ["\n  query UserMenuQuery {\n    viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  }\n"])));
// @ts-ignore
var UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    // static fragments = {
    //   viewer: gql`
    //     fragment UserMenu_viewer on Viewer {
    //       userId
    //       locale
    //       serverTime
    //       displayName
    //       companyName
    //       isLogin
    //       isBusiness
    //       isActiveBusiness
    //       buyer {
    //         approvalFlag
    //       }
    //       unreadMessageCount
    //     }
    //   `,
    // };
    function UserMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            over: false,
        };
        return _this;
    }
    UserMenu.prototype.render = function () {
        var viewer = this.props.viewer;
        var over = this.state.over;
        var iconClassName = 'login';
        var image;
        var userMenuList;
        if (viewer && viewer.isLogin) {
            TdWebService_1.default.setMemberId(viewer.userId);
            if (over) {
                userMenuList = react_1.default.createElement(UserMenuList_1.default, { viewer: viewer });
            }
            iconClassName = 'user';
            if (viewer.isBusiness) {
                iconClassName = 'userbiz';
            }
            image = react_1.default.createElement("div", { className: "util-icon " + iconClassName });
        }
        else {
            image = react_1.default.createElement(LoginLink_1.default, null);
        }
        return (react_1.default.createElement("div", { id: "userMenu" },
            image,
            viewer && viewer.unreadMessageCount > 0 && (react_1.default.createElement(Counter_1.default, { top: true, count: viewer.unreadMessageCount })),
            userMenuList));
    };
    UserMenu.propTypes = {
        viewer: prop_types_1.default.any,
    };
    UserMenu = __decorate([
        react_aim_1.source({
            mouseEnter: function (props, component) {
                // @ts-ignore
                return component.setState({ over: true });
            },
            mouseLeave: function (props, component) {
                // @ts-ignore
                return component.setState({ over: false });
            },
        }),
        __metadata("design:paramtypes", [Object])
    ], UserMenu);
    return UserMenu;
}(react_1.default.Component));
UserMenu.fragments = {
    viewer: graphql_tag_1.default(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment UserMenu_viewer on Viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  "], ["\n    fragment UserMenu_viewer on Viewer {\n      userId\n      locale\n      serverTime\n      displayName\n      companyName\n      isLogin\n      isBusiness\n      isActiveBusiness\n      buyer {\n        approvalFlag\n      }\n      unreadMessageCount\n    }\n  "]))),
};
exports.default = UserMenu;
var templateObject_1, templateObject_2;
